import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

export interface BackendVersionInfo {
    version: string;
    name: string;
}

@Injectable({
    providedIn: 'root'
})
export class BackendVersionService {

    constructor(private _httpClient: HttpClient) {}

    getVersion(): Observable<BackendVersionInfo> {
        return this._httpClient.get<BackendVersionInfo>(`${environment.apiUrl}/app/version`);
    }
}
